"use client";

import type { FC } from "react";
import { Flex, useThemeSlot } from "@huub-web/ui";

import { DefaultPageHeading } from "../../components/DefaultPageHeading/DefaultPageHeading";

export type AdviceHeadingTemplateProps = Record<string, never>;

export const AdviceHeadingTemplate: FC<AdviceHeadingTemplateProps> = ({
  ref,
}) => {
  const PageHeading = useThemeSlot({
    key: "pageHeading",
    defaultComponent: DefaultPageHeading,
  });

  return (
    <Flex ref={ref} direction="column" gap="s">
      <PageHeading scope="advice" />
    </Flex>
  );
};
